import styled from '@emotion/styled'
import { Box, Icon, Typography } from '@material-ui/core'
import { colors, typography } from '@resiliatech/birdsong'

export const FunderGoalsEmptyStateContainer = styled(Box)`
  display: flex;
  padding: 20px;
  width: 100%;
  height: 1000px;
  justify-content: center;
  align-items: center;
`

export const ContentWrapper = styled(Box)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  justify-content: space-between;
  align-items: center;
`

export const Header = styled(Typography)`
  ${typography.up3.regularSerif}
  line-height: 1.2;
  margin-bottom: 16px;
`

export const Subheader = styled(Typography)`
  ${typography.baseline.regularSans}
  margin-bottom: 24px;
`

export const CtaContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 45%;
`

export const ButtonContainer = styled(Box)`
  width: 230px;
  display: flex;
  justify-content: space-between;
`

export const SampleGoalImage = styled.img`
  width: 50%;
  max-height: 500px;
  object-fit: contain;
`

export const EmptyStateHeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 24px;
  border: 1px solid ${colors.interactive.borderEnabledHoverGray};
  border-radius: 8px;
  width: 100%;
`

export const HeaderContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  width: 100%;
`

export const IconWrapper = styled(Icon)`
  margin-right: 16px;
  color: ${colors.text.disabled};
`

export const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const SectionHeader = styled(Typography)`
  ${typography.up1.regularSerif}
  color: ${colors.text.primary};
  margin-bottom: 8px;
`

export const SectionSubheader = styled(Typography)`
  ${typography.down1.regularSans}
  color: ${colors.text.primary};
`
